export enum CSVFormat {
  CustomBreaks = 'Custom (Breaks)',
  CustomSpins = 'Custom (Spins)',
  Hawkeye = 'Hawkeye',
  Statcast = 'Statcast',
  Unknown = 'Unknown',
}
export enum QualityError {
  /** if format is statcast */
  Statcast = 'Statcast',
  /** if breaks are missing */
  BreakDetails = 'BreakDetails',
  /** if seam lat, lon, or orientation are missing */
  SeamDetails = 'SeamDetails',
}
